import { MaxLengthIssue } from '../types';
import resolveNonNegativeInteger from './resolveNonNegativeInteger';

const resolveMaxLengthIssue = (maxLength: string): MaxLengthIssue | null => {
  const trimmedValue = maxLength.trim();

  if (trimmedValue === '') {
    return null;
  }

  if (Number.isNaN(Number(trimmedValue))) {
    return 'notANumber';
  }

  // Mirrors what applyTextExportOptions accepts, so the error state and the trimming never disagree.
  return resolveNonNegativeInteger(trimmedValue) === undefined
    ? 'invalid'
    : null;
};

export default resolveMaxLengthIssue;
